import { Directive, forwardRef, HostBinding, inject, Input } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yBooleanInput } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yField]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yFieldDirective) }]
})
export class A11yFieldDirective extends A11yLabelDirective {
  private readonly ngControl = inject(NgControl, { optional: true, self: true });

  @Input() public ariaRequired: A11yBooleanInput = null;
  @Input() public ariaInvalid: A11yBooleanInput = null;

  @HostBinding('attr.aria-required')
  public get required(): 'true' | 'false' | null {
    if (this.ariaRequired !== null && this.ariaRequired !== undefined) {
      return toBoolean(this.ariaRequired, true) ? 'true' : 'false';
    }

    return this.isControlRequired ? 'true' : null;
  }

  @HostBinding('attr.aria-invalid')
  public get invalid(): 'true' | 'false' | null {
    if (this.ariaInvalid !== null && this.ariaInvalid !== undefined) {
      return toBoolean(this.ariaInvalid, true) ? 'true' : 'false';
    }

    const control = this.ngControl?.control;

    return control?.invalid && (control.touched || control.dirty) ? 'true' : null;
  }

  private get isControlRequired(): boolean {
    const control = this.ngControl?.control;

    return !!control?.hasValidator(Validators.required) || !!control?.hasValidator(Validators.requiredTrue);
  }
}
